var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "catalog-layout catalog row",
      class: { "is-loading": _vm.showLoader }
    },
    [
      _vm.$slots.aside
        ? _c(
            "aside",
            { staticClass: "col-md-3 hidden-mobile aside--left" },
            [
              _vm._t("aside"),
              _vm._v(" "),
              _c("LazyHydrate", { attrs: { never: "" } }, [
                _vm.isSearchPage
                  ? _c("div", {
                      staticClass: "dfpAd",
                      attrs: { id: "div-gpt-ad-1676540201424-0" }
                    })
                  : !_vm.isMobile
                  ? _c("div", {
                      staticClass: "dfpAd",
                      attrs: { id: "div-gpt-ad-RECTANGLE-0" }
                    })
                  : _vm._e()
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content",
          class: _vm.$slots.aside ? "col-md-9" : "col-md-12"
        },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }